import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function ProductDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);

  const product = {
    id: 1,
    name: 'أرز بسمتي هندي فاخر',
    price: 45,
    oldPrice: 55,
    rating: 4.8,
    reviews: 1250,
    stock: 45,
    images: [
      'https://public.readdy.ai/ai/img_res/8b5218abfdf85a5414d201079b095a3a.jpg',
      'https://readdy.ai/api/search-image?query=premium%20basmati%20rice%20bag%205kg%20side%20view%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=375&height=375&seq=pd2&orientation=squarish',
      'https://readdy.ai/api/search-image?query=premium%20basmati%20rice%20grains%20close%20up%2C%20professional%20food%20photography%2C%20clean%20white%20background%2C%20high%20quality%20commercial%20photo%2C%20centered%20composition%2C%20soft%20lighting%2C%20realistic%20details&width=375&height=375&seq=pd3&orientation=squarish'
    ],
    description: 'أرز بسمتي هندي فاخر من أجود أنواع الأرز، حبة طويلة ورائحة زكية. مثالي لجميع أنواع الأطباق العربية والهندية. معبأ بعناية فائقة للحفاظ على الجودة والنكهة الأصلية.',
    features: [
      'حبة طويلة فاخرة',
      'رائحة طبيعية زكية',
      'سهل الطبخ',
      'غني بالعناصر الغذائية',
      'معبأ بإحكام'
    ],
    provider: {
      name: 'بقالة الخير',
      rating: 4.9,
      deliveryTime: '30-45 دقيقة'
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
        <div className="px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/products')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-[#212121] text-2xl"></i>
          </button>
          <h1 className="text-[#212121] text-lg font-bold">تفاصيل المنتج</h1>
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-share-line text-[#212121] text-xl"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16">
        {/* Product Images */}
        <div className="bg-white mb-3">
          <div className="relative h-96">
            <img 
              src={product.images[selectedImage]} 
              alt={product.name} 
              className="w-full h-full object-cover object-top" 
            />
            <div className="absolute top-4 right-4 bg-[#FF8F00] text-white text-sm font-bold px-3 py-1.5 rounded-full shadow-lg">
              خصم 18%
            </div>
          </div>
          
          {/* Image Thumbnails */}
          <div className="flex gap-2 p-4">
            {product.images.map((img, index) => (
              <button
                key={index}
                onClick={() => setSelectedImage(index)}
                className={`w-20 h-20 rounded-xl overflow-hidden border-2 transition-all ${
                  selectedImage === index ? 'border-[#0D47A1]' : 'border-gray-200'
                }`}
              >
                <img src={img} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="bg-white p-5 mb-3">
          <h1 className="text-[#212121] text-xl font-bold mb-3">{product.name}</h1>
          
          <div className="flex items-center gap-4 mb-4">
            <div className="flex items-center gap-1">
              <i className="ri-star-fill text-[#FF8F00] text-lg"></i>
              <span className="text-[#212121] font-bold">{product.rating}</span>
              <span className="text-gray-500 text-sm">({product.reviews} تقييم)</span>
            </div>
            <div className="flex items-center gap-1 text-[#4CAF50]">
              <i className="ri-checkbox-circle-fill"></i>
              <span className="text-sm font-medium">متوفر ({product.stock} قطعة)</span>
            </div>
          </div>

          <div className="flex items-center gap-3 mb-4">
            <span className="text-[#0D47A1] text-3xl font-bold">{product.price} ر.س</span>
            <span className="text-gray-400 text-lg line-through">{product.oldPrice} ر.س</span>
          </div>

          {/* Provider Info */}
          <div className="bg-[#F6F6F6] rounded-xl p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-[#0D47A1] to-[#1976D2] rounded-full flex items-center justify-center">
                <i className="ri-store-2-fill text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-[#212121] font-bold text-sm">{product.provider.name}</h3>
                <div className="flex items-center gap-2 text-xs text-gray-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-[#FF8F00]"></i>
                    {product.provider.rating}
                  </span>
                  <span>•</span>
                  <span>{product.provider.deliveryTime}</span>
                </div>
              </div>
            </div>
            <button className="text-[#0D47A1] text-sm font-medium">
              زيارة المتجر
            </button>
          </div>
        </div>

        {/* Description */}
        <div className="bg-white p-5 mb-3">
          <h2 className="text-[#212121] text-lg font-bold mb-3">الوصف</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">{product.description}</p>
          
          <h3 className="text-[#212121] font-bold mb-3">المميزات</h3>
          <div className="space-y-2">
            {product.features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-[#4CAF50]"></i>
                <span className="text-gray-700 text-sm">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50">
        <div className="flex items-center gap-3">
          {/* Quantity Selector */}
          <div className="flex items-center bg-[#F6F6F6] rounded-xl">
            <button
              onClick={() => setQuantity(Math.max(1, quantity - 1))}
              className="w-10 h-12 flex items-center justify-center"
            >
              <i className="ri-subtract-line text-[#212121] text-xl"></i>
            </button>
            <span className="w-12 text-center font-bold text-[#212121]">{quantity}</span>
            <button
              onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
              className="w-10 h-12 flex items-center justify-center"
            >
              <i className="ri-add-line text-[#212121] text-xl"></i>
            </button>
          </div>

          {/* Add to Cart Button */}
          <button
            onClick={() => navigate('/cart')}
            className="flex-1 bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-3.5 rounded-xl font-bold text-base shadow-lg active:scale-95 transition-transform flex items-center justify-center gap-2"
          >
            <i className="ri-shopping-cart-line text-xl"></i>
            أضف للسلة - {product.price * quantity} ر.س
          </button>
        </div>
      </div>
    </div>
  );
}